<template>
  <div class="h5-recharge">
    <div class="page-header">
      <h1>便捷充值</h1>
      <p>输入手机号与金额，一键充值余额</p>
    </div>

    <div class="form-card" v-loading="loading">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        @submit.native.prevent="onSubmit"
      >
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model.trim="form.mobile"
            type="tel"
            maxlength="11"
            clearable
            placeholder="请输入用户手机号"
            @blur="lookupUser"
          />
        </el-form-item>

        <div v-if="user" class="user-info">
          <div class="row">
            <span class="label">昵称</span>
            <span class="value">{{ user.nickname || "-" }}</span>
          </div>
          <div class="row">
            <span class="label">UID</span>
            <span class="value">{{ user.uid }}</span>
          </div>
          <div class="row">
            <span class="label">当前余额</span>
            <span class="value money">￥{{ user.money }}</span>
          </div>
        </div>

        <el-form-item label="充值金额" prop="pay_money">
          <el-input
            v-model.trim="form.pay_money"
            type="number"
            clearable
            placeholder="请输入充值金额"
          >
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>

        <el-button
          class="submit-btn"
          type="primary"
          native-type="submit"
          :loading="loading"
          :disabled="!user"
        >
          确认充值
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { userIndex, setpay } from "@/request/api/user";

export default {
  name: "H5Recharge",
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
        callback(new Error("请输入充值金额"));
        return;
      }
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        callback(new Error("金额需大于 0"));
        return;
      }
      callback();
    };
    return {
      loading: false,
      user: null,
      form: {
        mobile: "",
        pay_money: ""
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        pay_money: [{ required: true, validator: validateMoney, trigger: "blur" }]
      }
    };
  },
  methods: {
    async lookupUser() {
      if (!/^1\d{10}$/.test(this.form.mobile)) {
        this.user = null;
        return;
      }
      this.loading = true;
      try {
        const res = await userIndex({
          page: 1,
          keyword: this.form.mobile,
          is_focus_mp: -1,
          is_money: -1,
          is_lock: -1,
          is_free: -1,
          is_commission: -1,
          is_score: -1,
          agent_uid: "",
          create_time: [],
          sort: ""
        });
        const list = (res && res.list) || [];
        const matched = list.find(item => String(item.mobile) === this.form.mobile);
        if (!matched) {
          this.user = null;
          this.$message.warning("未找到该手机号对应用户");
          return;
        }
        this.user = matched;
      } catch (e) {
        this.user = null;
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        if (!this.user) {
          await this.lookupUser();
          if (!this.user) return;
        }
        try {
          await this.$confirm(
            `确认为「${this.user.nickname || this.user.mobile}」(UID:${
              this.user.uid
            }) 充值 ￥${this.form.pay_money}？`,
            "确认充值",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          );
        } catch (e) {
          return;
        }
        this.loading = true;
        try {
          await setpay({
            uid: this.user.uid,
            pay_money: this.form.pay_money
          });
          this.$message.success("充值成功");
          this.form.pay_money = "";
          await this.lookupUser();
        } catch (e) {
          // 错误已在 request 层提示
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.h5-recharge {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px 16px 40px;
  background: linear-gradient(180deg, #e8f1ff 0%, #f5f7fa 40%, #f5f7fa 100%);
}

.page-header {
  margin-bottom: 20px;
  text-align: center;
}

.page-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #1f2d3d;
}

.page-header p {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
}

.form-card {
  max-width: 420px;
  margin: 0 auto;
  padding: 20px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.user-info {
  margin: -4px 0 16px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
}

.user-info .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 1.8;
}

.user-info .label {
  color: #909399;
}

.user-info .value {
  color: #303133;
  font-weight: 500;
}

.user-info .money {
  color: #e6a23c;
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
  height: 44px;
  font-size: 16px;
}

::v-deep .el-form-item__label {
  padding: 0 0 6px;
  line-height: 1.2;
  color: #606266;
}

::v-deep .el-input__inner {
  height: 42px;
  line-height: 42px;
}
</style>
